import { render } from "./tariffNewPlan.vue?vue&type=template&id=17480b02"
import script from "./tariffNewPlan.vue?vue&type=script&lang=js"
export * from "./tariffNewPlan.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__